import { Command } from 'commander';
import { readFileSync, existsSync } from 'fs';
import { fileURLToPath } from 'url';
import { dirname, join } from 'path';

const __dirname = dirname(fileURLToPath(import.meta.url));

// Resolve completions directory. Try multiple paths to handle dist and src layouts.
function completionsDir(): string {
  // Try ../../completions first (dist/commands/completion.ts → ../../completions or src/commands/completion.ts → ../../completions)
  const a = join(__dirname, '..', '..', 'completions');
  if (existsSync(a)) return a;
  // Try ../completions (in case of flatter dist)
  const b = join(__dirname, '..', 'completions');
  if (existsSync(b)) return b;
  return a;
}

const SHELL_TO_FILE: Record<string, string> = {
  bash: 'cloudgrid.bash',
  zsh: 'cloudgrid.zsh',
  fish: 'cloudgrid.fish',
};

export const completionCommand = new Command('completion')
  .description('Emit shell completion script')
  .argument('<shell>', 'bash | zsh | fish')
  .action((shell: string) => {
    const name = SHELL_TO_FILE[shell];
    if (!name) {
      process.stderr.write(`Error: unknown shell '${shell}'. Use bash, zsh, or fish.\n`);
      process.exit(2);
    }
    const path = join(completionsDir(), name);
    if (!existsSync(path)) {
      process.stderr.write(`Error: completion script not found at ${path}. Reinstall the CLI.\n`);
      process.exit(10);
    }
    process.stdout.write(readFileSync(path, 'utf-8'));
  });
